import { NavLink, useLocation } from 'react-router-dom';
import { Contact, Building2, Users, Handshake, CalendarDays } from 'lucide-react';
import { cn } from '@/lib/utils';

const CRM_TABS = [
  { to: '/crm', icon: Contact, label: 'Dashboard', tour: 'nav-crm-dashboard' },
  { to: '/crm/customers', icon: Building2, label: 'Customers', tour: 'nav-crm-customers' },
  { to: '/crm/contacts', icon: Users, label: 'Contacts', tour: 'nav-crm-contacts' },
  { to: '/crm/deals', icon: Handshake, label: 'Deals', tour: 'nav-crm-deals' },
  { to: '/crm/appointments', icon: CalendarDays, label: 'Appointments', tour: 'nav-crm-appointments' },
];

export default function CrmSubNav() {
  const location = useLocation();
  const isActive = (path: string) =>
    path === '/crm' ? location.pathname === '/crm' : location.pathname.startsWith(path);

  return (
    <nav className="sticky top-14 z-30 flex items-center gap-1 border-b border-border bg-muted/30 px-4 overflow-x-auto backdrop-blur-sm">
      {CRM_TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          data-tour={tab.tour}
          className={cn(
            'flex items-center gap-1.5 whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors',
            isActive(tab.to)
              ? 'border-primary text-primary'
              : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground'
          )}
        >
          <tab.icon className="h-4 w-4" />
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
